'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ISO_8601_FORMAT = exports.ISO_8601_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
var ISO_8601_DATE_FORMAT = exports.ISO_8601_DATE_FORMAT = 'YYYY-MM-DD';

var DEFAULT_DATETIME_FORMAT = exports.DEFAULT_DATETIME_FORMAT = 'llll';
var DEFAULT_TIMEZONE = exports.DEFAULT_TIMEZONE = 'UTC';
var DEFAULT_LANGUAGE = exports.DEFAULT_LANGUAGE = 'en_us';

var FULL_TIME_FORMAT = exports.FULL_TIME_FORMAT = 'HH:mm:ss A';
var DEFAULT_TIME_FORMAT = exports.DEFAULT_TIME_FORMAT = 'LT';